import { Injectable } from '@angular/core';
import { FabricService } from '../fabric/fabric.service';
import { Observable } from 'rxjs';
import { ChangeTask } from '../../models/service/change-task';
import { KeyValueMap } from '../../models/key-value-map';

const SERVICE_NAME = 'change-task-resources';

@Injectable({
  providedIn: 'root'
})
export class ChangeTaskService {

  constructor(private fabricService: FabricService) { }

  getChangeTasks(params?: any): Observable<ChangeTask[]> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'get_change-tasks', params);
  }

  getDeferrals(): Observable<any> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'get_change-tasks_deferrals');
  }

  deferUpdate(changeTaskId: string, deferralReason: string): Observable<ChangeTask> {
    // Typo in "deferalReason" is on purpose, since this is how it is defined in swagger spec
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'post_change-tasks_id_rejected',
      {id: changeTaskId, deferalReason: deferralReason});
  }
}
